import { environment } from '../environments/environment';
export class AppConfig{
    

    //localhost settings
    //public readonly apiUrl = 'http://localhost:49226';
    //public readonly baseUrl = 'https://localhost:4200';
    //public readonly client_id = 'UOkFRbufwc9ljX6pMTahC9clPy4lcvJ9';

    //beta settings
    //public readonly apiUrl = 'https://testing-api.constantcaretechnology.com';
    //public readonly baseUrl = 'https://testing.constantcaretechnology.com';
    //public readonly client_id = 'RsVlH6RG6EjRY5mYayTAix8s8fHklklQ';

    public readonly apiUrl = environment.apiUrl;
    public readonly baseUrl = environment.baseUrl;
    public readonly client_id = environment.client_id;
}



// WEBPACK FOOTER //
// ./src/app/app.config.ts